import { Action, createReducer, on } from '@ngrx/store';
import { fetchHomeDataSuccessAction } from '@home/store/actions/home.actions';
import { fetchHomeItemDetailSuccessAction } from '@home-item-detail/store/actions/home-item-detail.actions';
import { fetchPrimeModalEnable } from '@app/store/actions/global.actions';

export const initialState = false;

export const featureReducer = createReducer(
  initialState,
  on(
    fetchHomeDataSuccessAction,
    fetchHomeItemDetailSuccessAction,
    (state, { response }) => {
      return response.visibility_only_prime;
    }),
  on(
    fetchPrimeModalEnable,
    (state, { isEnable }) => {
      return isEnable;
    }),
);

export const modalPrimeReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};

